import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IRiskMapping } from '../models';

@Injectable({ providedIn: 'root' })
export class RiskMappingsService {
    constructor(private http: HttpClient) {}

    getRiskMappings(): Observable<IRiskMapping[]> {
        return this.http.get(`api/riskMappings`).pipe(map((response: any) => response as IRiskMapping[]));
    }
}
